"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PhoneCallConfirmationInfo = require("./PhoneCallConfirmationInfo");
Object.keys(_PhoneCallConfirmationInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PhoneCallConfirmationInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PhoneCallConfirmationInfo[key];
    }
  });
});